var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "86B86F3F-C077-4A9E-B2B3-E5576F35706C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-43.8%",
    y: "-40.6%",
    width: "187.5%",
    height: "193.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-66.7%",
    y: "-133.3%",
    width: "233.3%",
    height: "366.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Final-Template-Arun",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Campaign-Manager---Auto-1.0",
    transform: "translate(-60.000000, -229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-272",
    filter: "url(#filter-1)",
    transform: "translate(65.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#E02834",
    strokeWidth: 2,
    fill: "#FFBD00",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1940259,11.5000372 C24.0543583,14.3287425 24.5764651,16.9989287 23.2936939,18.2790913 C22.8113465,18.7593484 22.1385717,19 21.3172213,19 C20.6078257,19 19.7917079,18.8210808 18.8918833,18.4621958 C18.1155242,18.1524859 17.3077762,17.701527 16.5000272,17.170524 C15.6912326,17.7020503 14.8834842,18.1524883 14.1081711,18.4621958 C13.2083478,18.8210808 12.3901364,19 11.6828334,19 C10.8604367,19 10.1876616,18.7593484 9.70636079,18.2790913 C8.42358925,16.9989287 8.94569606,14.3287412 10.8049822,11.5000372 C8.94569606,8.67133315 8.42358925,6.00114565 9.70636079,4.72098303 C10.6040917,3.82638638 12.1651805,3.76308471 14.1081697,4.53787857 C14.8834822,4.84758839 15.6912312,5.29854732 16.5000259,5.82955033 C17.3077745,5.29802399 18.1155228,4.84758605 18.891882,4.53787857 C20.8380135,3.76203839 22.399102,3.82795603 23.2936943,4.72098303 C24.5764651,6.00114565 24.0543583,8.67133315 22.1940259,11.5000372 Z M15.5541664,16.4993148 C14.7840015,15.9247824 14.0547116,15.2974007 13.3715716,14.6217076 C12.6871072,13.9416779 12.0508101,13.214827 11.4672942,12.4464253 C10.0338547,14.765053 9.69694394,16.7551382 10.4649329,17.5215625 C11.032031,18.085 12.2122655,18.0656446 13.708482,17.4676773 C14.305923,17.2285937 14.9284752,16.8864501 15.5541664,16.4993148 Z M11.4683405,10.553648 C12.6318444,9.01633074 14.0074822,7.65178249 15.5541664,6.50075949 C14.9284752,6.11362422 14.3069693,5.77148024 13.7084823,5.53239799 C12.9363081,5.22425915 12.2488849,5.0699279 11.6849261,5.0699279 C11.1565414,5.0699279 10.7390649,5.20594844 10.4659792,5.47851283 C9.69694394,6.24545949 10.0348996,8.23502232 11.4683405,10.553648 Z M16.5000272,15.8772826 C17.3417071,15.2702331 18.1338131,14.5972544 18.8688647,13.8647018 C19.6053369,13.131867 20.2820133,12.3412993 20.8924209,11.5005612 C20.2822801,10.6596126 19.6055859,9.86902423 18.8688647,9.13642053 C18.1337193,8.40396988 17.3416217,7.73099825 16.5000272,7.12383973 C15.657883,7.73071308 14.8654158,8.40370152 14.1301437,9.13642053 C13.3934494,9.86875416 12.7170822,10.6593693 12.1076338,11.5005612 C12.717349,12.3415428 13.3936984,13.1321372 14.1301437,13.8647018 C14.8656866,14.5971264 15.6581296,15.2700943 16.5000272,15.8772826 L16.5000272,15.8772826 Z M18.3791981,11.5000372 C18.3808848,12.2604692 17.9241132,12.946965 17.2220503,13.2391421 C16.5199874,13.5313192 15.7110377,13.371578 15.172732,12.8344684 C14.6344263,12.2973588 14.4728859,11.4887665 14.7635006,10.7860554 C15.0541152,10.0833443 15.7395933,9.62504654 16.5000272,9.62504654 C17.5361584,9.62522574 18.3767093,10.463909 18.3791981,11.5000372 L18.3791981,11.5000372 Z M17.3046384,11.5000372 C17.305271,11.1742011 17.109452,10.8801061 16.8085801,10.7550234 C16.5077083,10.6299408 16.1611076,10.6985336 15.9305571,10.9287856 C15.7000065,11.1590376 15.6309646,11.5055491 15.7556572,11.8065828 C15.8803499,12.1076165 16.1741909,12.3038164 16.5000275,12.3036051 C16.7133197,12.3038561 16.9179634,12.2193088 17.0688815,12.0685861 C17.2197996,11.9178634 17.304612,11.7133294 17.3046384,11.5000372 L17.3046384,11.5000372 Z M17.4448417,6.50075949 C18.2155614,7.0750098 18.9452184,7.70240622 19.6284831,8.37836607 C20.3126199,9.05840051 20.9485687,9.78525274 21.5317143,10.553648 C22.9651538,8.23502132 23.3031105,6.24493616 22.5340755,5.47851283 C21.9701164,4.91612031 20.7888366,4.93547701 19.2915724,5.53239799 C18.6930851,5.77148024 18.0715792,6.11414721 17.4448417,6.50075949 L17.4448417,6.50075949 Z M21.5317143,12.446426 C20.9482628,13.2145717 20.3123321,13.9414032 19.6284831,14.6217076 C18.9447561,15.2971661 18.215135,15.9245316 17.4448417,16.4993142 C18.0705329,16.8864494 18.6930851,17.2285934 19.2915724,17.4676757 C20.7877889,18.065643 21.9690701,18.0844767 22.5340755,17.5215608 C23.3031105,16.7551382 22.9651538,14.765053 21.5317143,12.446426 Z",
    id: "Shape",
    fill: "#E02834",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-252",
    filter: "url(#filter-2)",
    transform: "translate(7.000000, 19.000000)",
    fill: "#E02834",
    fontFamily: "RobotoCondensed-Light, Roboto Condensed",
    fontSize: 8,
    fontStyle: "condensed",
    fontWeight: 300,
    letterSpacing: 0.15625
  }, /*#__PURE__*/React.createElement("text", {
    id: "Accel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.115234375,
    y: 7
  }, "Accel"))), /*#__PURE__*/React.createElement("text", {
    id: "Accel",
    fontFamily: "RobotoCondensed-Bold, Roboto Condensed",
    fontSize: 8,
    fontStyle: "condensed",
    fontWeight: "bold",
    letterSpacing: 0.15625,
    fill: "#E02834"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.61914062,
    y: 26
  }, "Accel")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccel);
export default __webpack_public_path__ + "static/media/accel.26784b47.svg";
export { ForwardRef as ReactComponent };